import {SxProps} from '@mui/material';
import {pick} from 'lodash';
import {COMMON_STYLES} from '../../constants/styles';

export const STYLES = {
  ...pick(COMMON_STYLES, 'chartTitle'),
  root: {
    height: '100%',
    gap: 2,
  },
  tableRoot: {
    width: '100%',
    height: '400px',
    border: '1px solid #e0e0e0',
    tableLayout: 'fixed',
  },
  table: {
    borderCollapse: 'separate',
    tableLayout: 'fixed',
  },
  header: {
    color: '#333',
    fontWeight: '600',
    padding: '12px 16px',
    borderBottom: '1px solid #e0e0e0',
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
  headerTitle: {
    color: '#333',
    fontSize: '14px',
    fontWeight: '600',
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
  headerRow: {
    backgroundColor: '#f5f5f5',
  },
  cell: {
    padding: '8px 10px',
    borderBottom: '1px solid #e0e0e0',
    color: '#333',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center',
    userSelect: 'none',
  },
} as const satisfies SxProps;
